import React from 'react';
import { resolveUrl } from '../driver/driverUtils';

export const STATUS = {
  working: { label: 'Working', dot: 'bg-emerald-500', chip: 'bg-emerald-100 text-emerald-800' },
  assigned: { label: 'Assigned', dot: 'bg-blue-500', chip: 'bg-blue-100 text-blue-800' },
  available: { label: 'Available', dot: 'bg-green-500', chip: 'bg-green-100 text-green-800' },
  regular_off: { label: 'Regular day off', dot: 'bg-red-500', chip: 'bg-red-100 text-red-800' },
  exception_off: { label: 'Unavailable', dot: 'bg-orange-500', chip: 'bg-orange-100 text-orange-800' },
  absent: { label: 'Absent', dot: 'bg-orange-500', chip: 'bg-orange-100 text-orange-800' },
  sick: { label: 'Sick', dot: 'bg-orange-500', chip: 'bg-orange-100 text-orange-800' },
  day_off: { label: 'Day off', dot: 'bg-orange-500', chip: 'bg-orange-100 text-orange-800' },
  holiday: { label: 'On holiday', dot: 'bg-orange-500', chip: 'bg-orange-100 text-orange-800' },
  unavailable: { label: 'Unavailable', dot: 'bg-orange-500', chip: 'bg-orange-100 text-orange-800' },
  not_scheduled: { label: 'Not scheduled', dot: 'bg-slate-400', chip: 'bg-slate-100 text-slate-600' },
  inactive: { label: 'Inactive', dot: 'bg-slate-300', chip: 'bg-slate-100 text-slate-500' },
};
export const ABSENCE_OPTIONS = [['sick', 'Sick'], ['absent', 'Absent'], ['holiday', 'On holiday'], ['day_off', 'Day off'], ['unavailable', 'Unavailable']];

export const StatusPill = ({ status, testid }) => {
  const s = STATUS[status] || STATUS.available;
  return (
    <span className={`inline-flex items-center gap-1 text-[10px] font-black uppercase tracking-wider px-2 py-0.5 rounded-full ${s.chip}`} data-testid={testid}>
      <span className={`w-2 h-2 rounded-full ${s.dot}`} />{s.label}
    </span>
  );
};

export const PorterAvatar = ({ p, size = 32 }) => (
  p?.photo_url
    ? <img src={resolveUrl(p.photo_url)} alt={p.name} className="rounded-full object-cover shrink-0" style={{ width: size, height: size }} />
    : <span className="rounded-full bg-[color:var(--mv-navy)] text-white font-black inline-flex items-center justify-center shrink-0" style={{ width: size, height: size, fontSize: size * 0.4 }}>{(p?.name || '?').slice(0, 1).toUpperCase()}</span>
);

export const StaffingBadge = ({ job }) => {
  const map = {
    full: ['Fully staffed', 'bg-emerald-100 text-emerald-800'],
    under: [`Understaffed · needs ${job.porters_short} more`, 'bg-amber-100 text-amber-800'],
    none: [`No porters · needs ${job.porters_short}`, 'bg-red-100 text-red-800'],
  };
  const [label, cls] = map[job.staffing] || map.full;
  return <span className={`text-[10px] font-black uppercase tracking-wider px-2 py-0.5 rounded-full ${cls}`} data-testid={`staffing-${job.ref}`}>{label}</span>;
};

export const ymd = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
export const addDays = (s, n) => { const d = new Date(s + 'T00:00:00'); d.setDate(d.getDate() + n); return ymd(d); };
export const fmtDay = (s) => new Date(s + 'T00:00:00').toLocaleDateString('en-GB', { weekday: 'short', day: '2-digit', month: 'short' });
export const errMsg = (e, fb = 'Something went wrong.') => {
  const d = e?.response?.data?.detail;
  return typeof d === 'string' ? d : d?.message || fb;
};

// Runs fn(overrideReason). If the server says the person is unavailable, asks for a one-off override reason and retries.
export const withOverride = async (fn) => {
  try { return await fn(null); } catch (e) {
    const d = e?.response?.data?.detail;
    if (e?.response?.status === 409 && d?.code === 'unavailable') {
      const reason = window.prompt(`${d.message}\n\nTo override just this once, type a reason (it is recorded in the history):`);
      if (reason && reason.trim()) return fn(reason.trim());
      const err = new Error('cancelled'); err.cancelled = true; throw err;
    }
    throw e;
  }
};
